"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TemplateSchema = void 0;
const zod_1 = require("zod");
const slide_pin_1 = require("./slide-pin");
const quiz_pin_1 = require("./quiz-pin");
const open_question_pin_1 = require("./open-question-pin");
const word_cloud_pin_1 = require("./word-cloud-pin");
const base_pin_1 = require("./base-pin");
const StyleSetSchema = zod_1.z.object({
    id: zod_1.z.string().min(1),
    name: zod_1.z.string().min(1),
    colors: zod_1.z.array(zod_1.z.string().min(1)),
    styles: zod_1.z.array(base_pin_1.BaseStyleSchema),
});
const TemplateLayoutsSchema = zod_1.z.object({
    slidePinLayouts: zod_1.z.array(slide_pin_1.SlidePinLayoutTemplateSchema),
    quizPinLayouts: zod_1.z.array(quiz_pin_1.QuizPinLayoutTemplateSchema),
    openQuestionLayouts: zod_1.z.array(open_question_pin_1.OpenQuestionPinLayoutTemplateSchema),
    wordCloudLayouts: zod_1.z.array(word_cloud_pin_1.WordCloudPinLayoutTemplateSchema),
});
exports.TemplateSchema = zod_1.z.object({
    id: zod_1.z.string().min(1),
    name: zod_1.z.string().min(1),
    styleSets: zod_1.z.array(StyleSetSchema),
    layouts: TemplateLayoutsSchema,
});
//# sourceMappingURL=template.js.map